import { render, staticRenderFns } from "./DocumentTypesComponent.vue?vue&type=template&id=065a5711"
import script from "./DocumentTypesComponent.vue?vue&type=script&lang=js"
export * from "./DocumentTypesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports